import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { for: "documentClassId" }
const _hoisted_4 = {
  key: 0,
  class: "p-field p-col-6"
}
const _hoisted_5 = { for: "server" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = {
  key: 1,
  class: "p-field p-col-6"
}
const _hoisted_8 = { for: "port" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { for: "protocol" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = {
  key: 2,
  class: "p-field p-col-6"
}
const _hoisted_13 = { for: "encryption" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 3,
  class: "p-field p-col-12"
}
const _hoisted_16 = { for: "checkCertificate" }
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = { class: "p-field p-col-6" }
const _hoisted_19 = {
  key: 0,
  for: "user"
}
const _hoisted_20 = {
  key: 1,
  for: "user"
}
const _hoisted_21 = {
  key: 2,
  class: "p-error"
}
const _hoisted_22 = { class: "p-field p-col-6" }
const _hoisted_23 = {
  key: 0,
  for: "password"
}
const _hoisted_24 = {
  key: 1,
  for: "password"
}
const _hoisted_25 = {
  key: 2,
  class: "p-error"
}
const _hoisted_26 = { class: "p-field p-col-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "clientId" }, "Client ID *", -1)
const _hoisted_28 = {
  key: 0,
  class: "p-error"
}
const _hoisted_29 = { class: "p-field p-col-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "tenantId" }, "Tenant ID *", -1)
const _hoisted_31 = {
  key: 0,
  class: "p-error"
}
const _hoisted_32 = { class: "p-field p-col-12" }
const _hoisted_33 = { for: "inboxFolder" }
const _hoisted_34 = {
  key: 0,
  class: "p-error"
}
const _hoisted_35 = { class: "p-field p-col-12" }
const _hoisted_36 = { for: "validFolder" }
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = { class: "p-field p-col-12" }
const _hoisted_39 = { for: "errorFolder" }
const _hoisted_40 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.Validation.Dialogs.ChangeDocumentClass.DocumentClass')), 1),
      _createVNode(_component_Dropdown, {
        id: "documentClassId",
        modelValue: _ctx.value.documentClassId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.documentClassId) = $event)),
        options: _ctx.documentClasses,
        loading: _ctx.loading,
        optionValue: "documentClassId",
        optionLabel: "description",
        onChange: _ctx.update,
        placeholder: _ctx.$t('Squeeze.General.None'),
        showClear: true
      }, null, 8, ["modelValue", "options", "loading", "onChange", "placeholder"])
    ]),
    (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.Imports.Server')) + " *", 1),
          _createVNode(_component_InputText, {
            id: "server",
            modelValue: _ctx.value.server,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.server) = $event)),
            class: _normalizeClass({'p-invalid':_ctx.v$.server.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.update
          }, null, 8, ["modelValue", "class", "onChange"]),
          (_ctx.v$.server.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Server')})), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.Imports.Port')) + " *", 1),
          _createVNode(_component_InputNumber, {
            id: "port",
            modelValue: _ctx.value.port,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.port) = $event)),
            useGrouping: false,
            class: _normalizeClass({'p-invalid':_ctx.v$.port.$invalid && _ctx.showErrorMessage}),
            onChange: _ctx.update
          }, null, 8, ["modelValue", "class", "onChange"]),
          (_ctx.v$.port.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Port')})), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["p-field", _ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated' ? 'p-col-6' : 'p-col-12'])
    }, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.Imports.Protocol')), 1),
      _createVNode(_component_Dropdown, {
        id: "protocol",
        modelValue: _ctx.value.protocol,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.protocol) = $event)),
        options: _ctx.protocols,
        loading: _ctx.loading,
        class: _normalizeClass({'p-invalid':_ctx.v$.protocol.$invalid && _ctx.showErrorMessage}),
        optionValue: "id",
        optionLabel: "description",
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeProtocol($event)))
      }, null, 8, ["modelValue", "options", "loading", "class"]),
      (_ctx.v$.protocol.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Protocol')})), 1))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('Squeeze.Imports.Encryption')), 1),
          _createVNode(_component_Dropdown, {
            id: "encryption",
            modelValue: _ctx.value.encryption,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.encryption) = $event)),
            options: _ctx.encryptions,
            loading: _ctx.loading,
            class: _normalizeClass({'p-invalid':_ctx.v$.encryption.$invalid && _ctx.showErrorMessage}),
            optionValue: "id",
            optionLabel: "description",
            onChange: _ctx.update
          }, null, 8, ["modelValue", "options", "loading", "class", "onChange"]),
          (_ctx.v$.encryption.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Encryption')})), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('Squeeze.Imports.CheckCert')), 1),
          _createVNode(_component_Dropdown, {
            id: "checkCertificate",
            modelValue: _ctx.value.checkCertificate,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value.checkCertificate) = $event)),
            options: _ctx.checkCertificates,
            loading: _ctx.loading,
            class: _normalizeClass({'p-invalid':_ctx.v$.checkCertificate.$invalid && _ctx.showErrorMessage}),
            optionValue: "id",
            optionLabel: "name",
            onChange: _ctx.update
          }, null, 8, ["modelValue", "options", "loading", "class", "onChange"]),
          (_ctx.v$.checkCertificate.$invalid && _ctx.showErrorMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.CheckCert')})), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
        ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(_ctx.$t('Squeeze.Login.UserName')) + " *", 1))
        : (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t('Squeeze.Imports.PostOfficeBox')) + " *", 1)),
      _createVNode(_component_InputText, {
        id: "user",
        modelValue: _ctx.value.user,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value.user) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.user.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.user.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Login.UserName')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      (_ctx.value.protocol !== 'microsoft' && _ctx.value.protocol !== 'microsoft_delegated')
        ? (_openBlock(), _createElementBlock("label", _hoisted_23, _toDisplayString(_ctx.$t('Squeeze.Login.Password')) + " *", 1))
        : (_openBlock(), _createElementBlock("label", _hoisted_24, "Client Secret *")),
      _createVNode(_component_Password, {
        id: "password",
        modelValue: _ctx.value.password,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.value.password) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.password.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        feedback: false,
        toggleMask: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.password.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Login.Password')})), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.value.protocol === 'microsoft' || _ctx.value.protocol === 'microsoft_delegated')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_InputText, {
              id: "clientId",
              modelValue: _ctx.value.clientId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value.clientId) = $event)),
              class: _normalizeClass({'p-invalid':_ctx.v$.clientId.$invalid && _ctx.showErrorMessage}),
              onChange: _ctx.update
            }, null, 8, ["modelValue", "class", "onChange"]),
            (_ctx.v$.clientId.$invalid && _ctx.showErrorMessage)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: 'Client ID'})), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_InputText, {
              id: "tenantId",
              modelValue: _ctx.value.tenantId,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.value.tenantId) = $event)),
              class: _normalizeClass({'p-invalid':_ctx.v$.tenantId.$invalid && _ctx.showErrorMessage}),
              onChange: _ctx.update
            }, null, 8, ["modelValue", "class", "onChange"]),
            (_ctx.v$.tenantId.$invalid && _ctx.showErrorMessage)
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: 'Tenant ID'})), 1))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('Squeeze.Imports.Inbox')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "inboxFolder",
        modelValue: _ctx.value.inboxFolder,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.value.inboxFolder) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.inboxFolder.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.inboxFolder.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Inbox')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Squeeze.Imports.Valid')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "validFolder",
        modelValue: _ctx.value.validFolder,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.value.validFolder) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.validFolder.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.validFolder.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Imports.Valid')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('Squeeze.General.Error')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "errorFolder",
        modelValue: _ctx.value.errorFolder,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.value.errorFolder) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.errorFolder.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.errorFolder.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.General.Error')})), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}